
// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('product.psychologicalprices', {
        url: '/psychologicalprices',
        views: {'productList@product': {
            templateUrl: 'main/product/psychologicalprices/psychologicalprices.tpl.html',
            controller: 'PsychologicalPricesController as vm'
        }},
        resolve: {
            psychologicalPrices: psychologicalPricesResolver
        }
    });
}

// @ngInject
function psychologicalPricesResolver(PsychologicalPricesApiService) {
    return PsychologicalPricesApiService.getPsychologicalPrices();
}

// @ngInject
function PsychologicalPricesController($rootScope, $state, $scope, psychologicalPrices, PsychologicalPricesApiService,loadSpinnerService) {
    var vm = this;

    vm.currentUser = $rootScope.currentUser;

    vm.psychologicalPrices = psychologicalPrices;
    vm.selectedPsychologicalPriceId = 0;
    vm.searchTerm = "";
    vm.currentPage = 1;
    vm.itemsPerPage = null;

    vm.searchTermChange = searchTermChange;

    activate();

    function activate() {
        $scope.$watch(function() { return $state.params.psychologicalPriceId; }, function(newValue, oldValue) {
            vm.selectedPsychologicalPriceId = parseInt($state.params.psychologicalPriceId, 10);
        });
        $rootScope.$on('PsychologicalPrice.Inserted', function(event, response) {
            loadPsychologicalPrices();
        });
        $rootScope.$on('PsychologicalPrice.Changed', function(event, response) {
            loadPsychologicalPrices();
        });
    }

    function loadPsychologicalPrices() {
        loadSpinnerService.start('mainSpinner');
        PsychologicalPricesApiService.getPsychologicalPrices(vm.currentPage,vm.searchTerm,vm.itemsPerPage).then(function(response) {
            vm.psychologicalPrices = response;
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner',{force: true});
        });
    }

    function searchTermChange() {
        vm.currentPage = 1;
        loadPsychologicalPrices();
    }

}

angular
    .module('product.psychologicalprices', ['psychologicalprices.api','psychologicalprices.psychologicalprice'])
    .config(stateConfig)
    .controller('PsychologicalPricesController', PsychologicalPricesController);
